exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media print{.dontprint[data-v-37dfd3ea]{display:none!important}.printed[data-v-37dfd3ea]{display:block!important}}.printed[data-v-37dfd3ea]{display:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-37dfd3ea","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/comisiones/Cartera.vue
// module id = 754
// module chunks = 0